var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmazenamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_15073",
    "data-name": "Grupo 15073",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.527,
    height: 44.527,
    viewBox: "0 0 44.527 44.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 22.263,
    cy: 22.263,
    r: 22.263,
    fill: "#009bde"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contract_FILL0_wght400_GRAD0_opsz48",
    d: "M123.247-855.263a3.131,3.131,0,0,1-2.3-.947,3.131,3.131,0,0,1-.947-2.3v-2.319a1.786,1.786,0,0,1,.545-1.31,1.786,1.786,0,0,1,1.31-.545h1.855v-15.461a1.786,1.786,0,0,1,.545-1.31,1.787,1.787,0,0,1,1.31-.545h14.842a1.787,1.787,0,0,1,1.31.545,1.786,1.786,0,0,1,.545,1.31v19.635a3.131,3.131,0,0,1-.947,2.3,3.131,3.131,0,0,1-2.3.947Zm15.767-1.855a1.352,1.352,0,0,0,.992-.4,1.343,1.343,0,0,0,.4-.991v-19.635H125.566v15.461h10.2a1.787,1.787,0,0,1,1.31.545,1.786,1.786,0,0,1,.545,1.31v2.319a1.348,1.348,0,0,0,.4.991A1.343,1.343,0,0,0,139.014-857.118Zm-10.665-15.461a.9.9,0,0,1-.661-.268.905.905,0,0,1-.267-.665.888.888,0,0,1,.267-.659.9.9,0,0,1,.661-.263h9.276a.9.9,0,0,1,.661.268.906.906,0,0,1,.267.665.888.888,0,0,1-.267.659.9.9,0,0,1-.661.263Zm0,3.711a.9.9,0,0,1-.661-.268.906.906,0,0,1-.267-.665.888.888,0,0,1,.267-.659.9.9,0,0,1,.661-.263h9.276a.9.9,0,0,1,.661.268.905.905,0,0,1,.267.665.888.888,0,0,1-.267.659.9.9,0,0,1-.661.263Zm-5.133,11.75H135.77v-3.711H121.855v2.319a1.343,1.343,0,0,0,.4.991A1.312,1.312,0,0,0,123.216-857.118Zm0,0h0Z",
    transform: "translate(-108.868 889.895)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmazenamento);
export default __webpack_public_path__ + "static/media/armazenamento.f325a3d664da9506544213f14fa949eb.svg";
export { ForwardRef as ReactComponent };